<template>
  <div class="deposit-pages">
    <div class="p8 align-items">
        <div>店员借领</div>
        <el-button type="primary" @click="addClick()" v-perm="{key:'staffBorrowInfo', value: 'staffBorrowInfo:add'}">新增借领</el-button>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row space-between">
              <div class="flex-row">
                <el-date-picker
                    v-model="query.reportMonth"
                    type="month"
                    :clearable="false"
                    value-format="yyyy-MM"
                    placeholder="选择日期"
                >
                </el-date-picker>
              </div>
              <div class="flex-row ml10">
                <el-select v-model="query.backStatus" class="select" placeholder="归还状态">
                  <el-option label="全部状态" value></el-option>
                  <el-option label="已归还" value="returned"></el-option>
                  <el-option label="待归还" value="notReturned"></el-option>
                  <el-option label="已领取" value="noReturnRequired"></el-option>
                </el-select>
              </div>
              <div class="flex-row ml10">
                <el-select v-model="query.borrowType" class="select" placeholder="借领类型">
                  <el-option label="全部类型" value></el-option>
                  <el-option label="借用" value="borrow"></el-option>
                  <el-option label="领取" value="receive"></el-option>
                </el-select>
              </div>
            </div>
            <el-button type="primary" class="ml10" @click="searchDoQuery">搜索</el-button>
          </div>
          <div class="m16 white" v-perm="{key:'staffBorrowInfo', value: 'staffBorrowInfo:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column
                :prop="index"
                :align="item.align"
                :label="item.label"
                :width="item.width"
                :min-width="item.minWidth"
                :show-overflow-tooltip="false"
                v-for="(item,index) in columns"
                :key="index"
              >
              <template slot-scope="scope">
                <div v-if="index == 'backStatus' && scope.row.backStatus == 'notReturned'" class="backStatusLabel">待归还</div>
                <div v-else-if="index == 'backStatus' && scope.row.backStatus == 'returnPart'" class="backStatusLabel">待归还</div>
                <div v-else-if="index == 'backStatus' && scope.row.backStatus == 'noReturnRequired'" class="blueLabel">已领取</div>
                <div v-else-if="index == 'backStatus' && scope.row.backStatus == 'returned'">已归还</div>
                <div v-else >{{Boolean(item.formatDay)?formatDate(scope.row[index]):scope.row[index]}}</div>
              </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" @click="handleClick(scope.row)">查看详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail-set ref="detailForm" @change="refreshPage"></detail-set>
    <addBorrowInfo-set ref="addBorrowInfoForm" @change="addBorrowInfo"></addBorrowInfo-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import detailSet from "./detail.vue";
import addBorrowInfoSet from "./addBorrowInfo.vue";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      url: this.$url.staffBorrowInfo.list,
      count: this.$url.staffBorrowInfo.count,
      columns: config.columns,
      query: {
        reportMonth: "",
        borrowType: "", //借领类型
        backStatus: "", //归还类型
        start: 1,
        size: 20,
        // lastRecordTime:0,
        // lastRecordId: "",
      },
      totalCount: 0,
    };
  },
  components: {detailSet,addBorrowInfoSet},
  created() {
    this.query.reportMonth = this.formatMonth(new Date())
    this.totalCounts();
  },

  methods: {
    searchDoQuery() {
      this.query.start = 1
      this.totalCounts();
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    handleClick (item, index) {
      this.$refs["detailForm"].$emit("set", item.id);
    },
    refreshPage(org) {
      if (org) {
        this.getData();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.staffBorrowInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res || 0;
      }).catch(error => {});
    },
    addClick(item) {
      console.log(item)
      this.$refs["addBorrowInfoForm"].$emit("set");
    },
    addBorrowInfo(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.page-head {
  // position: relative;
  height: 100%;
}
.deposit-pages {
  position: relative;
  // padding: 16px 16px 0;
}
.mains-content {
  background-color: #fff;
  border-radius: 10px;
  .member-header {
    background: #fff;
    padding: 16px 16px 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    .top-label {
      width: 90px;
    }
  }
}

.backStatusLabel {
    color: #F5A623;
  }
  .blueLabel {
    color: #62C87F;
  }

</style>